import React from "react";
import { ScrollView, View, useWindowDimensions } from "react-native";
import { Divider } from "@rneui/base";
import { Theme, ThemeConsumer } from "@rneui/themed";
import { printHtml } from '../../platform/printer/printer';

//common components
import { ZenButton, ZenText } from 'zen-core-elements'
import CommonHeader from "../../shared/commonComponents/commonHeader";
import CommonService from "../../shared/services/commonService";
import { useAppSelector } from "../../redux/hooks";

import { useAppNavigation, useAppRoute } from "../../types/@react-navigation/navigation";


const PrintCustomer = () => {
    const navigation = useAppNavigation()
    //variable which holds route params
    const { params } = useAppRoute("PrintCustomer")
    const { width } = useWindowDimensions()
    const currencySymbol = useAppSelector((state) => state?.common?.currentUser?.value?.purchasedCurrency?.currencySymbol) ?? '₹'
    const accountSettings = [{ "name": "On-Account Balance", value: CommonService.currencyStandard(currencySymbol, "50") }, { "name": "Allow On-Account Balance", value: "yes upto the limit of " + CommonService.currencyStandard(currencySymbol, "100") }, { "name": "Limit avalilable", value: CommonService.currencyStandard(currencySymbol, "40") }, { "name": "Total spent", value: CommonService.currencyStandard(currencySymbol, "50") }, { "name": "Last 12 months", value: CommonService.currencyStandard(currencySymbol, "50") }]
    const loyalty = [{ "name": "Balance", value: CommonService.currencyStandard(currencySymbol, "5") }, { "name": "Total earned/issued", value: CommonService.currencyStandard(currencySymbol, "25") }, { "name": "total redeemed", value: CommonService.currencyStandard(currencySymbol, "20") }]
    let html: any = `<html>
  <head>
    <style> 
      @page { margin: 0;}
    </style>
  </head>
  <body>
    <div style="padding:5px">
    <div style="display: flex; flex-direction: row;justify-content: space-between;margin-top:0px;">
      <div style="display: flex; flex-direction: column;margin-top:0px;width:55%;">
        <h6 style="float: left; font-size: 12px; margin: 0px;">Customer Profile</h6>
          <h6 style="display: inline; font-size: 10px;margin: 0px;margin-top:10px">
            Name: Stephen
          </h6>
          <h6 style="display: inline; font-size: 10px;margin: 0px;margin-top:5px">
           Gender: Male
          </h6>
          <h6 style="display: inline; font-size: 10px;margin: 0px;margin-top:5px">
          DOB: 12/03/2002
         </h6>
      </div>
      <div style="display: flex; flex-direction: column;align-items:flex-end;margin-top:0px;width:45%;">
        <h6 style="float: left; font-size: 12px; margin: 0px;">Contact Information</h6>
          <h6 style="display: inline; font-size: 10px;margin: 0px;margin-top:10px">
           Stephen@gmail.com
          </h6>
          <h6 style="display: inline; font-size: 10px;margin: 0px;margin-top:5px">
           +91 6789765456
          </h6>
          <h6 style="display: inline; font-size: 10px;margin: 0px;margin-top:5px;">
          Address:
         </h6>
         <h6 style="display: inline; font-size: 10px;margin: 0px;margin-top:5px;text-align:right">
         55 new street,near new road, new place ,6328849
          </h6>
      </div>
      </div>
      ${accountSettings?.length > 0 ?
            `<div style="display:flex;flex:1;flex-direction:column">
      <hr style="margin: 0px; margin-top: 5px; margin-bottom: 5px;">
     <div style="display:flex;flex:1;flex-direction:column">
      <h6 style="float: left; font-size: 12px; margin: 0px;">Account Settings</h6>
      <div style="display:flex;flex:1;flex-direction:column">
      ${accountSettings?.map((item: any) => (`<div style="display:flex;flex:1;flex-direction:row;justify-content: space-between;">
          <h6 style="font-size: 10px; margin: 5px 0px;">${item?.name}</h6>
          <h6 style="font-size: 10px; margin: 5px 0px;text-align:center;">${item?.value}</h6>
        </div>`
            )).join('')}
       </div>
      </div>
      </div>` : `<div></div>`}
      ${loyalty?.length > 0 ?
            `<div style="display:flex;flex:1;flex-direction:column">
      <hr style="margin: 0px; margin-top: 5px; margin-bottom: 5px;">
      <div style="display:flex;flex:1;flex-direction:column">
      <h6 style="float: left; font-size: 12px; margin: 0px;">Loyalty</h6>
      <div style="display:flex;flex:1;flex-direction:column;">
      ${loyalty?.map((item: any) => (`<div style="display:flex;flex:1;flex-direction:row;justify-content: space-between;">
          <h6 style="font-size: 10px; margin: 5px 0px;">${item?.name}</h6>
          <h6 style="font-size: 10px; margin: 5px 0px;text-align:center;">${item?.value}</h6>
        </div>`
            )).join('')}
       </div>
      </div>
      </div>`: `<div></div>`}
    </div>
    </div>
  </body>
</html>`
    const printData = async () => {
        await printHtml(html)
    }

    return (
        <ThemeConsumer>
            {({ theme }: { theme: Theme }) => (
                <View style={{ flex: 1 }}>
                    <CommonHeader headerName="Print customer details" backIcon backIconOnpress={() => { navigation?.goBack() }} />
                    <ScrollView showsVerticalScrollIndicator={false} style={{ backgroundColor: theme?.lightBackgroundColor }} contentContainerStyle={{ backgroundColor: theme?.light, marginHorizontal: 10, paddingHorizontal: 10, marginTop: 10, paddingTop: 10, borderRadius: 5 }}>
                        <View>
                            <View style={{ margin: width > 600 ? 10 : 0, }}>
                                <View style={theme?.printCustomerStyle?.profileView}>
                                    <View style={{ width: width > 600 ? "60%" : "45%" }}>
                                        <ZenText content={"Customer Profile"} bold={true} size={theme?.smallerFontSize} color={theme?.lightDark} />
                                        <ZenText content={params?.customerHistoryData?.user?.firstName + params?.customerHistoryData?.user?.lastName} size={theme?.smallerFontSize} color={theme?.dark} style={{ paddingVertical: 10 }} />
                                        <View style={theme?.customerListStyle?.mailContainer}>
                                            <ZenText content={"Gender:"} size={theme?.smallFontSize} color={theme?.grey} />
                                            <ZenText content={"Male"} size={theme?.smallerFontSize} color={theme?.dark} style={{ paddingLeft: 5 }} />
                                        </View>
                                        <View style={[theme?.customerListStyle?.mailContainer, { paddingVertical: 10 }]}>
                                            <ZenText content={"DOB:"} size={theme?.smallFontSize} color={theme?.grey} />
                                            <ZenText content={"10/01/2002"} size={theme?.smallerFontSize} color={theme?.dark} style={{ paddingLeft: 5 }} />
                                        </View>
                                    </View>
                                    <View style={{ alignItems: "flex-end", width: width > 600 ? "40%" : "55%" }}>
                                        <ZenText content={"Contact Information"} bold={true} size={theme?.smallerFontSize} color={theme?.dark} />
                                        <ZenText content={"customer@gmail.com"} size={theme?.smallerFontSize} color={theme?.dark} style={{ paddingVertical: 10 }} />
                                        <ZenText content={"+91 6381011695"} size={theme?.smallerFontSize} color={theme?.dark} />
                                        <View style={{ flexDirection: "row", paddingTop: 10, flexWrap: "wrap", }}>
                                            <ZenText content={"Address:"} size={theme?.smallFontSize} color={theme?.dark} />
                                        </View>
                                        <ZenText content={"55 new street,near new road, new place ,6328849"} size={theme?.smallFontSize} color={theme?.dark} numberOfLines={10} style={{ textAlign: "right" }} />
                                    </View>
                                </View>
                                <Divider width={0.34} style={{ marginVertical: width > 600 ? 20 : 10 }} />
                                <View >
                                    <ZenText content={"Account settings"} bold={true} size={theme?.smallerFontSize} color={theme?.dark} style={{ paddingBottom: 10 }} />
                                    {accountSettings?.map((settings: any, index) => (
                                        <View key={index} style={[theme?.printCustomerStyle?.loyaltyView]}>
                                            <View style={{ width: "70%", }}>
                                                <ZenText content={settings?.name} size={theme?.smallerFontSize} color={theme?.dark} />
                                            </View>
                                            <View style={{ width: "30%", alignItems: "flex-end" }}>
                                                <ZenText content={settings?.value} size={theme?.smallerFontSize} color={theme?.dark} numberOfLines={10} />
                                            </View>
                                        </View>
                                    ))}
                                </View>
                                <Divider width={0.34} style={{ marginVertical: width > 600 ? 20 : 10 }} />
                                <View>
                                    <ZenText content={"Loyalty"} bold={true} size={theme?.smallerFontSize} color={theme?.dark} style={{ paddingBottom: 10 }} />
                                    {loyalty?.map((settings: any, index) => (
                                        <View key={index} style={theme?.printCustomerStyle?.loyaltyView}>
                                            <ZenText content={settings?.name} size={theme?.smallerFontSize} color={theme?.dark} />
                                            <ZenText content={settings?.value} size={theme?.smallerFontSize} color={theme?.dark} />
                                        </View>
                                    ))}
                                </View>
                            </View>
                        </View>
                        <Divider width={0.34} style={{ marginTop: width > 600 ? 20 : 10 }} />
                        <View style={theme?.printCustomerStyle?.printButtonView}>
                            <ZenButton
                                onPress={() => {
                                    printData()
                                }}
                                title="Print"
                                type="solid"
                                buttonStyle={{ backgroundColor: theme?.primary, borderRadius: 10 }}
                                titleColor={theme?.light}
                                titleStyle={{ fontSize: theme.smallerFontSize }}
                            />
                        </View>
                    </ScrollView>
                </View>
            )
            }
        </ThemeConsumer >
    )
}
export default PrintCustomer